import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#101828',
  },
  heading: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#003149',
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  label: {
    color: '#344054',
    fontWeight: 'bold',
  },
  value: {
    color: '#101828',
  },
});

const ActiveDetailsPDF = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.heading}>Workers Report</Text>
      {data.map((item, index) => (
        <View key={index} style={styles.recordGroup}>
          <View style={styles.row}><Text style={styles.label}>ID:</Text><Text style={styles.value}>{item.id}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Worker Name:</Text><Text style={styles.value}>{item.admin}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Email:</Text><Text style={styles.value}>{item.email}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Phone No.:</Text><Text style={styles.value}>{item.phone}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Department:</Text><Text style={styles.value}>{item.department}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Type:</Text><Text style={styles.value}>{item.type}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Shift:</Text><Text style={styles.value}>{item.shift}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Status:</Text><Text style={styles.value}>{item.status}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Registered:</Text><Text style={styles.value}>{item.date}</Text></View>
        </View>
      ))}
    </Page>
  </Document>
);

export default ActiveDetailsPDF;